import React, { useEffect, useState } from 'react';
import {
  Button,
  InlineLoading,
  Link,
  InlineNotification
} from 'carbon-components-react';

const ArchiveSeries: React.FC<Props> = ({
  onClose,
  onRefreshTeamView,
  enquiryId,
  enquiryAutoRenewSeries,
  isArchive,
  archiveEnquiry,
  isArchivingEnquiry,
  archivedEnquiry
}) => {
  const [archiveSuccessful, setArchiveSuccessful] = useState<boolean>(false);
  const [disableArchiveButton, setDisableArchiveButton] =
    useState<boolean>(false);
  const [localArchive, setLocalArchive] = useState<boolean>(false);
  const [isMultiple, setIsMultiple] = useState<boolean>(true);

  const handleArchiveClick = (withSeries: boolean) => {
    setLocalArchive(true);
    setDisableArchiveButton(true);
    let enquiryIdArray = [];

    if (withSeries) {
      enquiryIdArray = enquiryAutoRenewSeries.map((ar) => ar.id);
    } else {
      setIsMultiple(false);
    }

    archiveEnquiry(enquiryId, enquiryIdArray, isArchive);
  };

  useEffect(() => {
    if (isArchivingEnquiry) {
      setDisableArchiveButton(true);
    }

    if (!isArchivingEnquiry && archivedEnquiry) {
      setTimeout(() => {
        setArchiveSuccessful(true);
      }, 1500);
    }
  }, [isArchivingEnquiry, archivedEnquiry]);

  return (
    <div className={`archive-series`}>
      {!archiveSuccessful && (
        <div>
          <InlineNotification
            kind="info"
            lowContrast
            hideCloseButton={true}
            title={'This enquiry is part of a series'}
          />
        </div>
      )}
      <div
        className={`archive-series-wrapper ${archiveSuccessful ? 'moved' : ''}`}
      >
        {!archiveSuccessful ? (
          <>
            <div className="archive-series-title">Please choose</div>
            <div className="archive-series-button-container">
              <div className="only-buttons">
                <Button kind="tertiary" size="field" onClick={() => onClose()}>
                  Back
                </Button>

                <Button
                  kind="secondary"
                  size="field"
                  disabled={disableArchiveButton || isArchivingEnquiry}
                  onClick={() => handleArchiveClick(true)}
                >
                  {!isArchivingEnquiry && !localArchive ? (
                    `${isArchive ? 'Archive' : 'Restore'} series (${
                      enquiryAutoRenewSeries.length
                    })`
                  ) : isMultiple ? (
                    <InlineLoading
                      description={
                        !isArchivingEnquiry
                          ? `${isArchive ? 'Archived' : 'Restored'} series (${
                              enquiryAutoRenewSeries.length
                            })`
                          : `${isArchive ? 'Archive' : 'Restore'} series (${
                              enquiryAutoRenewSeries.length
                            })`
                      }
                      status={!isArchivingEnquiry ? 'finished' : 'active'}
                      aria-live={'assertive'}
                    />
                  ) : (
                    `${isArchive ? 'Archive' : 'Restore'} series (${
                      enquiryAutoRenewSeries.length
                    })`
                  )}
                </Button>
              </div>
              <div className="archive-link-container">
                <div>
                  <Link
                    onClick={() => handleArchiveClick(false)}
                    disabled={disableArchiveButton || isArchivingEnquiry}
                  >
                    {isArchive ? 'Archive' : 'Restore'} only this enquiry
                  </Link>
                </div>
                {((isArchivingEnquiry && !isMultiple) ||
                  (localArchive && !isMultiple)) && (
                  <InlineLoading
                    status={!isArchivingEnquiry ? 'finished' : 'active'}
                    aria-live={'assertive'}
                  />
                )}
              </div>
            </div>
          </>
        ) : (
          <div className="archive-series-success">
            <div className="archive-series-title">
              {isMultiple
                ? `${enquiryAutoRenewSeries.length} enquiries`
                : '1 enquiry'}{' '}
              {isArchive ? 'archived' : 'restored'}
            </div>
            <div className="archive-series-button-container">
              <Button
                kind="tertiary"
                size="field"
                onClick={() => onRefreshTeamView()}
              >
                Refresh view
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

type Props = {
  onClose: Function;
  enquiryId: number;
  onRefreshTeamView: Function;
  enquiryAutoRenewSeries: any[];
  isArchive: boolean;
  archiveEnquiry: Function;
  isArchivingEnquiry?: boolean;
  archivedEnquiry: any;
};

export default React.memo(ArchiveSeries);
